import frCommon from './fr/common.json';
import frParent from './fr/parent.json';
import enCommon from './en/common.json';
import enParent from './en/parent.json';

function isPlainObject(value) {
  return value != null && typeof value === 'object' && !Array.isArray(value);
}

function mergeDeep(target, source) {
  const output = { ...target };

  for (const [key, value] of Object.entries(source)) {
    if (isPlainObject(value) && isPlainObject(output[key])) {
      output[key] = mergeDeep(output[key], value);
    } else {
      output[key] = value;
    }
  }

  return output;
}

function mergeMessages(...parts) {
  return parts.reduce((acc, part) => mergeDeep(acc, part), {});
}

const messages = {
  fr: mergeMessages(frCommon, frParent),
  en: mergeMessages(enCommon, enParent),
};

export default messages;
